import * as React from 'react';
import { PropsWithChildren } from 'react';
import { ClassNameBuilder } from '../utils/ClassNameBuilder';

export const PanelBody: React.FC<PropsWithChildren<React.HTMLProps<HTMLDivElement>>> = ({
    className,
    children,
    ...others
}) => {
    const classBuilder = new ClassNameBuilder(className);
    classBuilder.add('panel-body', true);

    return (
        <>
            <div className={classBuilder.build()} {...others}>
                {children}
            </div>
        </>
    );
};
